"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Flame, Leaf, Waves, Star, Utensils, ChevronDown, Wine, Sparkles, Download, MessageCircle } from "lucide-react";
export default function VistaDelMenu() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const [activeCategory, setActiveCategory] = useState("Todos");
  const [activeType, setActiveType] = useState("Todos");
  const [expandedCategory, setExpandedCategory] = useState<string | null>("Entradas");
  const menuItems = [{
    id: 1,
    category: "Entradas",
    name: "Aguachile de Sandía",
    description: "Sandía curada, pepino, cebolla morada y chiltepín.",
    price: "$210",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/watermelon_aguachile_fresh.png"
  }, {
    id: 2,
    category: "Entradas",
    name: "Tostada de Atún",
    description: "Atún fresco, mayonesa de chipotle y crujiente de puerro.",
    price: "$285",
    type: "Mariscos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/tuna_tostada_premium.png"
  }, {
    id: 3,
    category: "Entradas",
    name: "Esquites de Lujo",
    description: "Maíz tierno, mayonesa de hormiga chicatana y queso cotija.",
    price: "$195",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/luxury_esquites_corn.png"
  }, {
    id: 4,
    category: "Entradas",
    name: "Ceviche de Pesca del Día",
    description: "Pescado blanco, leche de tigre de maracuyá y camote.",
    price: "$310",
    type: "Mariscos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/catch_day_ceviche.png"
  }, {
    id: 5,
    category: "Entradas",
    name: "Tacos de Lechón",
    description: "Confit de lechón, puré de aguacate y salsa verde tatemada.",
    price: "$260",
    type: "Picante",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/suckling_pig_tacos.png"
  }, {
    id: 6,
    category: "Entradas",
    name: "Queso Fundido con Chorizo",
    description: "Mezcla de quesos artesanales y chorizo de la casa.",
    price: "$225",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/melted_cheese_chorizo.png"
  }, {
    id: 7,
    category: "Fuertes",
    name: "Pulpo a las Brasas",
    description: "Pulpo marinado en adobo de chiles secos y puré de camote.",
    price: "$540",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/grilled_octopus_signature.png"
  }, {
    id: 8,
    category: "Fuertes",
    name: "Mole Negro con Pato",
    description: "Pechuga de pato, mole oaxaqueño artesanal y arroz criollo.",
    price: "$620",
    type: "Picante",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/black_mole_duck.png"
  }, {
    id: 9,
    category: "Fuertes",
    name: "Filete de Res en Cenizas",
    description: "Filete premium costreado en ceniza de cebolla y vegetales.",
    price: "$680",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/ash_crusted_beef.png"
  }, {
    id: 10,
    category: "Fuertes",
    name: "Pescado a la Talla",
    description: "Filete de temporada abierto con dos adobos tradicionales.",
    price: "$510",
    type: "Mariscos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/pescado_talla_grill.png"
  }, {
    id: 11,
    category: "Fuertes",
    name: "Risotto de Hongos Silvestres",
    description: "Arroz cremoso con variedad de hongos de temporada.",
    price: "$420",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/wild_mushroom_risotto.png"
  }, {
    id: 12,
    category: "Fuertes",
    name: "Costilla Corta en Mezcal",
    description: "Braseada por 12 horas en reducción de mezcal y agave.",
    price: "$590",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/mezcal_short_rib.png"
  }, {
    id: 13,
    category: "Fuertes",
    name: "Enchiladas de Camarón",
    description: "Rellenas de camarón con salsa de chile poblano.",
    price: "$445",
    type: "Mariscos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/shrimp_enchiladas_poblano.png"
  }, {
    id: 14,
    category: "Fuertes",
    name: "Chile en Nogada Contemporáneo",
    description: "Receta clásica con un giro de autor y granada fresca.",
    price: "$480",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/modern_chile_nogada.png"
  }, {
    id: 15,
    category: "Postres",
    name: "Tamal de Chocolate",
    description: "Chocolate amargo, crema de mezcal y frutos rojos.",
    price: "$185",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/chocolate_tamal_dessert.png"
  }, {
    id: 16,
    category: "Postres",
    name: "Flan de Elote",
    description: "Textura cremosa con caramelo de piloncillo.",
    price: "$160",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/corn_flan_mexican.png"
  }, {
    id: 17,
    category: "Postres",
    name: "Churros Gourmet",
    description: "Acompañados de salsa de cajeta y chocolate oaxaqueño.",
    price: "$175",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/gourmet_churros_dips.png"
  }, {
    id: 18,
    category: "Postres",
    name: "Sorbetes de Temporada",
    description: "Tres sabores frutales elaborados artesanalmente.",
    price: "$140",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/seasonal_sorbets_fresh.png"
  }, {
    id: 19,
    category: "Postres",
    name: "Pastel de Tres Leches y Coco",
    description: "Bizcocho húmedo con coco tostado y vainilla.",
    price: "$195",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/coconut_tres_leches.png"
  }, {
    id: 20,
    category: "Postres",
    name: "Marquesita Marea",
    description: "Crujiente rellena de queso de bola y chocolate.",
    price: "$155",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/marea_marquesita_special.png"
  }, {
    id: 21,
    category: "Cócteles",
    name: "Marea Roja",
    description: "Mezcal Espadín, jamaica, canela y un toque de sal de gusano.",
    price: "$240",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/red_marea_cocktail.png"
  }, {
    id: 22,
    category: "Cócteles",
    name: "Margarita de Humo",
    description: "Tequila reposado, mezcal, cítricos y carbón activado.",
    price: "$225",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/smoke_margarita_black.png"
  }, {
    id: 23,
    category: "Cócteles",
    name: "Paloma del Caribe",
    description: "Tequila blanco, toronja fresca, soda y sal de mar.",
    price: "$210",
    type: "Mariscos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/caribbean_paloma_drink.png"
  }, {
    id: 24,
    category: "Cócteles",
    name: "Gin de Lavanda",
    description: "Ginebra nacional, infusión de lavanda y tónica premium.",
    price: "$235",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/lavender_gin_tonic.png"
  }, {
    id: 25,
    category: "Cócteles",
    name: "Mezcalini de Pepino",
    description: "Mezcal joven, pepino, albahaca y jarabe de agave.",
    price: "$220",
    type: "Vegetariano",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/cucumber_mezcalini_fresh.png"
  }, {
    id: 26,
    category: "Cócteles",
    name: "Carajillo Oaxaqueño",
    description: "Café espresso, Licor 43 y un toque de mezcal añejo.",
    price: "$250",
    type: "Especial del Chef",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/oaxacan_carajillo_coffee.png"
  }];
  const categories = ["Todos", "Entradas", "Fuertes", "Postres", "Cócteles"];
  const types = ["Todos", "Vegetariano", "Mariscos", "Picante", "Especial del Chef"];
  const filteredItems = menuItems.filter(item => {
    const categoryMatch = activeCategory === "Todos" || item.category === activeCategory;
    const typeMatch = activeType === "Todos" || item.type === activeType;
    return categoryMatch && typeMatch;
  });
  const toggleCategory = (cat: string) => {
    setExpandedCategory(expandedCategory === cat ? null : cat);
  };
  const getTypeIcon = (type: string) => {
    const iconClass = "size-5 text-accent";
    switch (type) {
      case "Vegetariano":
        return <Leaf className={iconClass} />;
      case "Mariscos":
        return <Waves className={iconClass} />;
      case "Picante":
        return <Flame className={iconClass} />;
      case "Especial del Chef":
        return <Star className={iconClass} />;
      default:
        return <Utensils className={iconClass} />;
    }
  };
  return <section id="menu" ref={sectionRef} className="py-32 px-6 bg-muted-light-background relative overflow-hidden">
      <div className="max-w-5xl mx-auto">
        <div className={`text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <p className="text-sm font-medium text-accent-dark uppercase tracking-widest mb-2">
            Precios en MXN · Servicio 15% no incluido
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Nuestro Menú
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-12">
            Una selección cuidadosamente curada de sabores auténticos y presentación elegante
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <Utensils className="size-8 text-accent-dark" />
        </div>
        <div className="mb-12 space-y-6">
          <div className="flex flex-wrap justify-center gap-2">
            {categories.map((cat, i) => <Button key={cat} data-index={i} variant={activeCategory === cat ? "default" : "outline"} onClick={() => setActiveCategory(cat)} className={`rounded-full px-6 transition-all duration-200 hover:scale-100 hover:translate-y-0 ${activeCategory === cat ? "bg-primary text-white border-primary" : "border-primary/20 text-foreground hover:border-primary bg-transparent"}`}>
                {cat}
              </Button>)}
          </div>
          <div className="flex flex-wrap justify-center pb-2 scrollbar-hide gap-4 px-4">
            {types.map((type, i) => <Button key={type} data-index={i} variant="ghost" onClick={() => setActiveType(type)} className={`text-sm font-medium flex items-center gap-1.5 transition-all duration-200 px-3 py-1 rounded-md h-auto shrink-0 hover:scale-100 hover:translate-y-0 ${activeType === type ? "bg-accent/10 text-accent ring-1 ring-accent" : "text-muted-foreground hover:text-foreground hover:bg-accent/5"}`}>
                {type !== "Todos" && getTypeIcon(type)}
                {type}
              </Button>)}
          </div>
        </div>

        <div className="flex justify-center mb-12">
          <Flame className="size-8 text-accent-dark" />
        </div>
        <div className="space-y-6 min-h-[400px]">
          {categories.slice(1).map((cat, i) => {
          const itemsInCat = filteredItems.filter(item => item.category === cat);
          if (itemsInCat.length === 0 && activeCategory !== "Todos" && activeCategory !== cat) return null;
          if (itemsInCat.length === 0 && activeCategory === "Todos") return null;
          return <div key={cat} data-index={i} className="bg-white rounded-xl shadow-soft overflow-hidden border border-accent/10 transition-all duration-300">
                <div className="w-full">
                  <Button variant="ghost" onClick={() => toggleCategory(cat)} className="w-full flex items-center justify-between p-6 h-auto text-left hover:bg-muted/30 transition-colors rounded-none group">
                    <div className="flex flex-col gap-1 w-full">
                      <h3 className="text-2xl font-display font-semibold text-secondary group-hover:text-primary transition-colors">
                        {cat}
                      </h3>
                      <Separator className="bg-accent/30 w-16 h-[2px]" />
                    </div>
                    <ChevronDown className={`size-6 text-accent-dark transition-transform duration-300 ${expandedCategory === cat ? "rotate-180" : ""}`} />
                  </Button>
                </div>
                
                <div className={`transition-all duration-200 ease-in-out ${expandedCategory === cat ? "max-h-[5000px] opacity-100 pb-8" : "max-h-0 opacity-0 overflow-hidden"}`}>
                  <div className="px-6 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-10 mt-4 overflow-hidden">
                    {itemsInCat.map((item, j) => <div key={item.id} data-index={j} className="group flex flex-col sm:flex-row gap-6 p-2 rounded-lg hover:bg-muted/20 transition-all duration-300">
                        <div className="relative aspect-[4/3] sm:w-40 shrink-0 overflow-hidden rounded-md bg-muted shadow-sm">
                          <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                        </div>
                        <div className="flex-1 flex flex-col justify-between py-1">
                          <div>
                            <div className="flex justify-between items-start mb-2 gap-4">
                              <h4 className="font-display font-bold text-xl text-foreground group-hover:text-primary-dark transition-colors leading-tight">
                                {item.name}
                              </h4>
                              <span className="font-sans font-bold text-xl text-secondary whitespace-nowrap">{item.price}</span>
                            </div>
                            <p className="text-sm text-muted-foreground mb-4 line-clamp-2 italic">
                              {item.description}
                            </p>
                          </div>
                          <div className="flex items-center gap-2 mt-auto">
                            <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded bg-accent/5 border border-accent/10">
                              {getTypeIcon(item.type)}
                              <span className="text-[10px] uppercase tracking-wider text-accent-dark font-bold">
                                {item.type}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>;
        })}
        </div>

        {}
        <div className="flex justify-center mt-20 mb-4">
          <Sparkles className="size-8 text-accent-dark" />
        </div>
        <div className={`mt-16 transition-all duration-[var(--duration-medium)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="bg-secondary p-10 md:p-16 rounded-xl text-white relative overflow-hidden shadow-soft border border-accent/30">
            <div className="absolute top-0 right-0 p-4 opacity-10">
              <Sparkles className="size-32" />
            </div>
            <div className="relative z-10 flex flex-col md:flex-row gap-10 items-center">
              <div className="flex-1 text-center md:text-left">
                <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
                  <h3 className="text-3xl md:text-4xl font-display font-bold">
                    Menú Degustación Marea Mezcal
                  </h3>
                  <div className="inline-flex items-center self-center md:self-auto gap-2 px-3 py-1 rounded-full bg-accent/20 border border-accent/40 text-accent-dark">
                    <Star className="size-4 fill-accent" />
                    <span className="text-xs font-bold uppercase tracking-widest">Experiencia Signature</span>
                  </div>
                </div>
                <p className="text-white/80 mb-6 text-lg">
                  Un viaje sensorial de 7 tiempos que recorre las costas y montañas de México, maridado con nuestra selección privada de mezcales.
                </p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-sm text-white/90">
                  <li className="flex items-center gap-2"><Wine className="size-4 text-[#C6A75E]" /> Bienvenida con Mezcal Ancestral</li>
                  <li className="flex items-center gap-2"><Utensils className="size-4 text-[#C6A75E]" /> Crudo de Mar y Cítricos</li>
                  <li className="flex items-center gap-2"><Utensils className="size-4 text-[#C6A75E]" /> Tostada de Maíz Azul y Hormiga Chicatana</li>
                  <li className="flex items-center gap-2"><Utensils className="size-4 text-[#C6A75E]" /> Pesca del Día en Pipían Verde</li>
                  <li className="flex items-center gap-2"><Utensils className="size-4 text-[#C6A75E]" /> Cordero en Cenizas de Chile</li>
                  <li className="flex items-center gap-2"><Utensils className="size-4 text-[#C6A75E]" /> Postre de Cacao y Sal de Mar</li>
                </ul>
                <div className="flex flex-col sm:flex-row items-center gap-8">
                  <div className="flex flex-col items-center sm:items-start">
                    <span className="text-4xl font-display font-bold text-[#C6A75E] leading-tight">$2,450 MXN</span>
                    <span className="text-sm font-sans font-normal text-white/60">por persona</span>
                  </div>
                  <Link to="https://wa.me/1234567890">
                    <Button className="bg-primary text-white border-none px-8 py-6 text-lg rounded-md transition-all hover:bg-primary/90 hover:scale-100 hover:translate-y-0 active:scale-100">
                      Reservar Experiencia
                    </Button>
                  </Link>
                </div>
              </div>
              <div className="w-full md:w-1/3 aspect-square rounded-lg overflow-hidden border-2 border-accent/20">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/degustacion_marea_premium.png" alt="Menú Degustación" className="w-full h-full object-cover saturate-50" />
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="flex justify-center mt-16">
          <ChevronDown className="size-8 text-accent-dark" />
        </div>
        <div className={`mt-16 flex flex-col sm:flex-row justify-center gap-4 transition-all duration-[var(--duration-medium)] delay-300 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="https://wa.me/1234567890" newTab className="w-full sm:w-auto">
            <Button size="lg" className="w-full text-lg px-8 py-6 bg-primary text-white hover:bg-primary-hover shadow-medium transition-all rounded-md flex items-center gap-2 hover:scale-100 hover:translate-y-0">
              <MessageCircle className="size-5 text-accent-dark" />
              Reservar Mesa por WhatsApp
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}